import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { isNull, isUndefined } from 'lodash';

import { Loading, LoadingError } from '@components/Base';
import HeaderSecondary from '@components/HeaderSecondary';
import { HealthQuotePremiumCardBody } from '@components/Feature/HealthQuote';
import HealthQuotePaymentForm, { FormValues } from '@components/HealthQuotePaymentForm';

import { paymentTransactionCreate, PaymentTransactionCreatePayload } from './action';
import { useBillingFetch, usePersonalAccidentQuoteFetch } from './hook';
import { selectPersonalAccidentQuotePaymentPage } from './selector';

const PersonalAccidentQuotePaymentPage = () => {
  const dispatch = useDispatch();
  const personalAccidentQuote = usePersonalAccidentQuoteFetch();
  const billing = useBillingFetch();
  const { paymentTransaction } = useSelector(selectPersonalAccidentQuotePaymentPage);

  if (isUndefined(personalAccidentQuote) || isUndefined(billing)) return <Loading />;
  if (isNull(personalAccidentQuote) || isNull(billing)) return <LoadingError />;

  const { personalAccidentPlanName } = personalAccidentQuote;
  const { chargeAmount, chargeAmountKhr } = billing;

  const handleSubmit = (values: FormValues) => {
    const payload: PaymentTransactionCreatePayload = { billingId: billing.id, ...values };
    dispatch(paymentTransactionCreate(payload));
  };

  return (
    <>
      <HeaderSecondary />
      <Container className="my-3">
        <Row>
          <Col lg={8} className="mx-auto">
            <Card>
              <HealthQuotePremiumCardBody
                {...personalAccidentQuote}
                totalPremium={chargeAmount}
                totalPremiumKhr={chargeAmountKhr}
                planName={personalAccidentPlanName} />

              <Card.Body>
                <HealthQuotePaymentForm onSubmit={handleSubmit} paymentTransaction={paymentTransaction} />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { PersonalAccidentQuotePaymentPage };
